import * as React from "react";
const SvgLayout = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M4 8h16V5H4zm10 11v-9h-4v9zm2 0h4v-9h-4zm-8 0v-9H4v9zM22 3v18H2V3z" })));
export default SvgLayout;
//# sourceMappingURL=Layout.js.map